// NTF: Weiches Scrollen zum Produktraster, wenn die URL auf #produkte endet
(function () {
  if (window.location.hash !== '#produkte') return;
  var target = document.getElementById('ProductGridContainer');
  if (!target) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  setTimeout(function () {
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }, 150);
})();